import { reactive, toRefs, onBeforeMount, onBeforeUnmount, onMounted, ref, computed,Ref, nextTick, watch,getCurrentInstance  } from 'vue'
import { useStore } from 'vuex'
import useReceiveMessage, { getCanvasLimitHeight } from '@/hooks/useReceiveMessage'
import useLoading3D from '@/hooks/useLoading3D'
import useSpeechSynthesis from '@/hooks/useSpeechSynthesis'
import { $enum, $config, $tips } from '@/global'
import {enterOrExitUavSimulateModule, switchOpenGuid, switchView, resetView, switchUnlockUav,forceGainFocus, refreshUserConfig, setPause, recordProcessMessage} from '@/webapi'
import { createTraining, getDefaultTrainingSetting, saveUserTrainingSetting, getTemplateTrainingSetting } from '@/service'
import CircleDrawer from '@/utils/drawer/CircleDrawer'
import useFlightEchartOptions from '@/hooks/useFlightEchartOptions'

interface IFlyingPropps {}

interface IFlyingEmit {
    (event: 'onBack'): void
}

enum PageName {
    加载中=1,
    飞行=2,
    成绩=3,
    设置=4
}

enum MassageType {
    无=0,
    悬停=1,
    自转=2,
    八字=3,
    降落=4,
    解锁=5
}

//科目模式
enum SceneMode {
    无=0,
    悬停=1,
    自旋=2,
    八字=3,
    全科=4
}

//报警类型
enum AlarmType {
    操作=1,
    异常=2
}

const colorMap: Record<string, string> = {
    'height': '#6BA4FF',
    'position': '#D57D0F',
    'timeDeviation': '#46B65B',
    'headAngle': '#FDE043',
    'angle': '#D279D3',
    'speed': '#38B6C7'
}




export default function useFlying(
    props: IFlyingPropps,
    emit: IFlyingEmit,
    timeBoxRef:any,
    timeBox:any,
    progressRef:any,
    flyCanvasRef:any,
    gradCanvasRef:any,
    promptRef:any,
    promptTextRef:any,
    flyDeviationInfoRef:any,
    gradeFlyDeviationInfoRef:any,
): any {
    const store = useStore()
    const { proxy } = getCurrentInstance() as any
    const typeMap = new Map([
        ['notifyRunningParam', 'notifyRunningParam'], //运行数据回调
        ['loadResourceFail', 'loadResourceFail'], //加载模型失败
        ['loadSceneResource', 'loadSceneResource'], //加载模型完成
        ['modelLoading', 'modelLoading'], //加载模型进度
        ['initializeEngineProgress', 'initializeEngineProgress'], //引擎初始化
        ['notifyEvaluateDetails','notifyEvaluateDetails'], //科目课堂详情
        ['extraLoadModelFiles','extraLoadModelFiles'], //额外的模型文件列表
        ['exitSimulateModuleSuccess','exitSimulateModuleSuccess'], //退出模拟模块成功
        ['rotatePartOneComplete','rotatePartOneComplete'], //旋转第一部分完成
    ])
    const state = reactive({
        sceneImage: $config.FILE_ROOT_PATH + store.state.persistence.currentUavInfo.sceneImageUrl,
        uavId: store.state.persistence.currentUavInfo.uavId,
        nestId: store.state.persistence.currentUavInfo.nestId,
        trainingId: store.state.persistence.currentUavInfo.trainingId,
        stationdId: store.state.persistence.stationId,
        sceneInfo:store.state.persistence.currentUavInfo.sceneInfo,
        resourceFileList:store.state.persistence.currentUavInfo?.resourceFileList[0] || [],
        windSpeedIndex:store.state.persistence.currentUavInfo.windSpeedIndex,
        windDirectionIndex:store.state.persistence.currentUavInfo.windDirectionIndex,
        userWaserInfo:{
            windSpeedIndex:store.state.persistence.userTrainSettingInfo.windPower,
            windDirectionIndex:store.state.persistence.userTrainSettingInfo.windDirection,
        },
        connectStatus: $enum.SWITCH_STATUS.OFF, // 遥控器连接状态
        lockStatus:$enum.SWITCH_STATUS.OFF,
        guidStatus:store.state.persistence.userTrainSettingInfo?.enableGuide, //引导状态
        characterMode:0,//视角类型,0为第三人称,1为第一人称,2为飞手视角
        propgressTimer: null as any, // 进度条计时器
        step: 1, // 进度条步长
        containerWidth: 0 as any, // 容器宽度
        isComputing: false, // 是否计算中
        isShowGrad:false,
        currentPage:PageName.加载中, //当前页面,
        pixiApp: store.state.viewData.pixiInstance, //pixi实例
        loading3D:{
            title:store.state.persistence.currentUavInfo.sceneInfo?.sceneSubTypeName,
            description:store.state.persistence.currentUavInfo.sceneInfo?.typeDescription,
            pageType:store.state.persistence.currentUavInfo.parentName,
        },
        finish:false,//是否训练完成
        gradScore:0,//得分
        evaluate:false,
        drawer:null as any, // 圆形绘制器实例
        alarmTimer:null as any, // 消息计时器
        alarmTimeCount:0,//消息显示时间
        totalTime:0,//总时间
        gradeTotalTime:0,//科目总时间
        pageVisible:true, //页面是否可见
        engineProgress:0,
        timer:null as any, // 倒计时计时器
        showAiInstructor:true, //是否显示ai教员
        showPrompt:false, //是否显示提示
        promptText:'', //提示文本
        showOpenAiPrompt:false, //是否显示打开ai提示
        isMarqueeActive:false, //是否显示跑马灯
        fpsStatus:60,
        canSetFps:true,
        collisionAlarm:false,
        crash:false,
        currentWindSpeed:'0.0',
        alarmType:AlarmType.操作,
        submitVideoUrl: `${$config.FILE_ROOT_PATH}${store.state.persistence.currentUavInfo.sceneInfo?.videoUrl || ''}`,
        subjectList:[] as any[],
        showSubjectModal:false,
        aiCoachSettlementData:null as null | {
            rating: '较差' | '良好' | '优秀',
            radar: {
                flight_stability: number,
                stick_proficiency: number,
                anti_disturbance: number,
                error_correction: number,
                deviation_control: number
            },
            flightConclusion: string,
            trainingSuggestion: string
        },
        permissionLevel:store.state.persistence.breadcrumb[0]?.permissionLevel,
        currentInfoMessage:null as string | null | undefined,
        currentErrorMessage:null as string | null | undefined,
        currentErrorAlarmCode:null as string | null | undefined,
        backByExitSimulateModule:false,
    })

    const operationPrompt = reactive({
        spinCompleted:false,//自旋完成
        delayTime:3000,
        hoverStarted:false,
    })

    const flyingState = reactive({
        evaluateStatus:{
            height:false,
            position:false,
            time:0,
            angle:false,
            angleMaxSpeed:false,
            angleMinSpeed:false,
            calculateAngleSpeed:false, //到达中心桶并且角速度第一次超过最小值时改为true
            maxSpeed:false,
            minSpeed:false,
            calculateMinSpeed:false, //到达中心桶并且最小速度第一次超过最小值时改为true
            collisionAlarm:false
        },
        totalSeconds: -1, // 飞行总时间 秒
        currentSeconds: 0, // 当前时间 秒
        uavStatusList: [],
        currentStepIndex:0,
        altitude:0,  //高度
        horizonalSpeed:0,//速度
        courseAngle:0, //航向角
        realTimeAngleOffset:0,//航向夹角
        angularSpeed:0,//角速度
        uavIconAngle:0, //无人机图标角度
        isShowAlarm:false,
        currentMessage:MassageType.无,
        onGround:false,
        arriveCenter:0,//是否到达中心
        resetting:0,
        flyingInfo:{} as any,
        isReady:false,
        currentUavPosition :null as any,
        flyDeviationViewMode:$enum.FlyDeviationViewMode.卡片,  //飞行数据视模式
    });

    const lightDirectionList =[
        {time:'07:00', angle:15},
        {time:'08:00', angle:30},
        {time:'09:00', angle:45},
        {time:'10:00', angle:60},
        {time:'11:00', angle:75},
        {time:'12:00', angle:90},
        {time:'13:00', angle:105},
        {time:'14:00', angle:120},
        {time:'15:00', angle:135},
        {time:'16:00', angle:150},
        {time:'17:00', angle:165},
    ]

    //场景设置状态
    const sceneSetting = reactive({
        sightHeight:store.state.persistence.userTrainSettingInfo?.sightHeight || 0,
        sightDist:store.state.persistence.userTrainSettingInfo?.sightDist || 0,
        sightFov:store.state.persistence.userTrainSettingInfo?.sightFov || 0,
        changeFovDist:store.state.persistence.userTrainSettingInfo?.changeFovDist || 0,
        lightDirection:store.state.persistence.userTrainSettingInfo?.lightDirection || -1,
        showAuxiliaryViewport:store.state.persistence.userTrainSettingInfo?.supportViewport || false,
        shadowEnable:store.state.persistence.userTrainSettingInfo?.shadowEnable || false,
        distance: store.state.persistence.userTrainSettingInfo?.distance || 6,
        usedTemplateId: store.state.persistence.userTrainSettingInfo?.usedTemplateId || 0,
        confirmLoading:false,
        resetLoading:false,
        perspectiveTab: 0, // 当前选中的Tab索引
        centerBucketDist: store.state.persistence.userTrainSettingInfo?.distance || 6, // 无人机到中心桶距离
        showTemplateTooltip: false, // 是否显示模版说明tooltip
        templateList: [] as any[], // 模板数据列表
    })

    // 视角设置Tab选项（动态生成，自定义模式已包含在 templateList 中）
    const perspectiveTabList = computed(() => {
        return sceneSetting.templateList.map((item: any) => item.templateName)
    })

    // 是否是自定义视角模式（通过 id 是否为 null 判断）
    const isCustomPerspective = computed(() => {
        const currentTemplate = sceneSetting.templateList[sceneSetting.perspectiveTab]
        return currentTemplate?.id === 0
    })

    const sceneMode = computed(() => {
        let mode = SceneMode.无;
        if(state.sceneInfo && state.sceneInfo?.sceneSubTypeName){
            if(/悬停/.test(state.sceneInfo?.sceneSubTypeName)){
                mode = SceneMode.悬停;
            }else if(/自旋/.test(state.sceneInfo?.sceneSubTypeName)){
                mode = SceneMode.自旋;
            }else if(/8字/.test(state.sceneInfo?.sceneSubTypeName)){
                mode = SceneMode.八字;
            }else if(/全科/.test(state.sceneInfo?.sceneSubTypeName)){
                mode = SceneMode.全科;
            }
        }
        return mode;
    });

    const subjectTitle = computed(() => {
        return state.sceneInfo?.title || '';
    })

    const { speak, stop} = useSpeechSynthesis()
    const { echart, initEcharts, resizeEcharts, updateRadarData } = useFlightEchartOptions()
    const updateFlyingInfo = (data:any) => {
        const max = Number(data?.maxValue || 0);
        const min = Number(data?.minValue || 0);
        if(data?.value>max&&data?.value<max+0.01){
            data.value = max+0.01
        }
        let value = Number(data?.value || 0);
        let realTimeValue = Number(data?.realTimeValue || 0);
        let lowerValue:any = Number(data?.lowerValue || 0);
        let higherValue:any = Number(data?.higherValue || 0);
        let range = max - min;
        let leftValue = Math.max(min, lowerValue);
        let rightValue = Math.min(max, higherValue);
        let progress = Math.min(1, (rightValue - leftValue) / range) * 100;
        let color = lowerValue < min || higherValue > max ? '#E70102' : '#2174FF ';
        let left = (leftValue - min) / range * 100;
        return {value,progress,max,min,name:data?.name, lowerValue, higherValue,color,left,realTimeValue,id:data?.id};
    }

    const updateFlightMetric = (data:any, metric:any,unit:string) => {
        if(!data) return;
        if(Array.isArray(data)){
            if(data.length){
                let arr:any[] = []
                data.forEach(item=>{
                    let {value,max,min,name, lowerValue, higherValue,realTimeValue,id} = updateFlyingInfo(item);
                    if(metric == 'timeDeviation' && sceneMode.value == SceneMode.悬停){
                        name = '用时偏差'
                        max = min
                    }
                    arr.push({
                        name,
                        id,
                        value:value.toFixed(0),
                        realTimeValue:realTimeValue.toFixed(0),
                        max,
                        min,
                        lowerValue:lowerValue.toFixed(2),
                        higherValue:higherValue.toFixed(2),
                        progress: 0,
                        color:'',
                        left:0,
                        unit,
                    });
                })
                flyingState.flyingInfo[metric] = arr
            }else{
                let name = flyingState.flyingInfo[metric][0]?.name
                flyingState.flyingInfo[metric] = [{
                    name,
                    id:flyingState.flyingInfo[metric][0]?.id,
                    value:0,
                    realTimeValue:0,
                    max:0,
                    min:0,
                    lowerValue:0,
                    higherValue:0,
                    progress: 0,
                    color:'',
                    left:0,
                    unit,
                }]
            }
        }else{
            let {value,progress,max,min,name, lowerValue, higherValue,color,left,realTimeValue,id} = updateFlyingInfo(data);
            if(metric == 'headAngle'){
                //夹角偏差
                lowerValue = lowerValue.toFixed(1)
                higherValue = higherValue.toFixed(1)
            }else{
                lowerValue = lowerValue.toFixed(2)
                higherValue = higherValue.toFixed(2)
            }
            flyingState.flyingInfo[metric] = {
                name,
                id,
                value,
                realTimeValue,
                max,
                min,
                lowerValue,
                higherValue,
                progress,
                color,
                left,
                unit
            };
        }
    }

    // 风向列表
    const windDirctionList = ['北风', '东北风', '东风', '东南风', '南风', '西南风', '西风', '西北风'];

    // 当前风向
    const currentWindDirection = computed(() => {
        if (state.windDirectionIndex === null || state.windDirectionIndex === undefined) {
            return '--';
        }
        return windDirctionList[state.windDirectionIndex] || '--';
    });

    const gradTotalTime = computed(() => {
        const totalSeconds = state.currentPage == PageName.成绩?state.gradeTotalTime:state.totalTime;
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = Math.floor(totalSeconds - minutes * 60); // 关键修改：计算真正的剩余秒数
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    });

    const loadingProgess = computed(() => {
        if(engineInitialized.value){
            return loadingState.progressValue;
        }else{
            return (state.engineProgress * 100).toFixed(2);
        }
    });

    watch(()=>state.showSubjectModal, (newVal)=>{
        if(newVal){
            setPause({statu:1})
        }else{
            setPause({statu:0})
        }
    })


     ///////////////////////////////////////////////////////



    const { loadingState, setLoadingStatus,engineInitialized, handleOpenPDF, storeSettlementData,setExtraFileMap, showOrHideEngineView } = useLoading3D(state.stationdId, state.resourceFileList, proxy)

    const { handleOpenSettingFullscreen, handleBack } = useReceiveMessage(typeMap, (type: string, data: any) => {
        if (type === 'notifyRunningParam' &&  state.currentPage !== PageName.成绩) {
            const { horizonalSpeed, yaw, taskData, joyStickMode, unLockStatu,yawAngleSpeed,homingData,onGround,openGuidStatu,notifyKeyList,triggerReset,characterMode, isReady,finishReset,fps,currentWindSpeed } = data.data || {}
            const { stepNameList, currentStepIndex, evaluateData,finish,targetTime, currentTime,score,isPass, mapYaw,mapPosition,totalTime,overLimit,arriveCenter, collisionAlarm, crash,realTimeAngleOffset, aiCoachSettlementData } = taskData || {}

            state.guidStatus = openGuidStatu;
            state.characterMode = characterMode;
            Object.assign(state,{
                lockStatus:unLockStatu,
                connectStatus:joyStickMode,
                collisionAlarm,
                crash,
                currentWindSpeed:currentWindSpeed?.toFixed(1) || '0.0',
                totalTime,
            })
            if(state.canSetFps){
                state.fpsStatus = fps;
            }

            if (notifyKeyList && notifyKeyList.length > 0)
            {
                notifyKeyList.forEach((item: string) => {
                    if(item == "Escape")
                    {
                        handleBack('Escape');
                    }else if(item == "F11"){
                        window.listenEvent.emit('toggle-full-screen');
                    }
                });
            }
            if(triggerReset)
            {
                handleSwitch("reset",true)
            }
            if(finishReset)
            {
                if(state.drawer){
                    state.drawer.reset(mapYaw);
                }
            }
            if(!finish){
                if(state.finish){
                    state.finish = false;
                }
                if(!flyingState.arriveCenter && arriveCenter){
                    flyingState.arriveCenter = arriveCenter;
                }
                normalPrompt({currentStepIndex,overLimit,stepNameList,arriveCenter,targetTime, isReady})
                 // 一次性更新飞行状态
                const prevIsReady = flyingState.isReady;
                Object.assign(flyingState, {
                    uavStatusList: stepNameList,
                    currentStepIndex,
                    altitude: homingData?.verticalDistance?.toFixed(2) || '0.00',
                    horizonalSpeed: horizonalSpeed?.toFixed(2) || '0.00',
                    angularSpeed: yawAngleSpeed.toFixed(1) || '0.0',
                    courseAngle: yaw?.toFixed(0) || '0',
                    realTimeAngleOffset:realTimeAngleOffset !== undefined?realTimeAngleOffset?.toFixed(0) || '0':undefined,
                    totalSeconds:targetTime,
                    currentSeconds:currentTime?.toFixed(0),
                    uavIconAngle:mapYaw?.toFixed(0),
                    isShowAlarm:overLimit == 1?true:false,
                    onGround:onGround,
                    isReady:isReady,
                })
                // 广播 isReady 状态变化给布局组件（仅在状态变化时广播）
                if (isReady && isReady !== prevIsReady) {
                    window.listenEvent.emit('is-ready-change', isReady);
                }

                if(!state.drawer && evaluateData?.["positionOffset"]){
                    const w = evaluateData?.["positionOffset"].maxValue * 10 * 2;
                    state.drawer = new CircleDrawer(flyCanvasRef.value,w,{x:mapPosition.x,y:mapPosition.y,yaw:mapYaw},true)
                }
                // flyingState.currentMessage = MassageType.解锁
                if(state.drawer && state.currentPage == PageName.飞行 && unLockStatu ==  $enum.SWITCH_STATUS.ON){
                    state.drawer.updateCompass({
                        x:mapPosition.x,
                        y:mapPosition.y,
                        yaw:mapYaw
                    })
                }
                if(state.drawer &&  unLockStatu ==  $enum.SWITCH_STATUS.OFF &&
                    (flyingState.currentUavPosition?.x != mapPosition.x || flyingState.currentUavPosition?.y != mapPosition.y)
                ){
                    flyingState.currentUavPosition = { x: mapPosition.x, y: mapPosition.y, yaw: mapYaw };
                    state.drawer.updateInitialCompassPos({ x: mapPosition.x, y: mapPosition.y, yaw: mapYaw });
                }
                if(evaluateData && typeof evaluateData == "object"){
                    const {
                        heightOffset,
                        positionOffset,
                        angleOffset,
                        angleSpeedOffset,
                        speedOffset,
                        targetTime,
                        time
                    } = evaluateData;
                    const isFirstInit = Object.keys(flyingState.flyingInfo).length === 0;
                    const shouldUpdate = isFirstInit ||flyingState.resetting|| (flyingState.arriveCenter && flyingState.currentMessage !== MassageType.降落);
                    if (shouldUpdate) {
                        if(flyingState.resetting){
                            flyingState.resetting--;
                        }
                        if (heightOffset !== undefined) updateFlightMetric(heightOffset, 'height', 'm');
                        if (positionOffset !== undefined) updateFlightMetric(positionOffset, 'position', 'm');
                        if (sceneMode.value === SceneMode.悬停) {
                            if (targetTime !== undefined) updateFlightMetric([targetTime], 'timeDeviation', 's');
                        } else {
                            if (time !== undefined) updateFlightMetric(time, 'timeDeviation', 's');
                        }
                        if (angleOffset !== undefined) updateFlightMetric(angleOffset, 'headAngle', '°');
                        if (angleSpeedOffset !== undefined) updateFlightMetric(angleSpeedOffset, 'angle', '°/s');
                        if (speedOffset !== undefined) updateFlightMetric(speedOffset, 'speed', 'm/s');
                        // 更新曲线数据
                        flyDeviationInfoRef?.value?.updateCurveData?.(flyingState.resetting ==0)
                    }
                }
                abnormalPrompt({evaluateData,collisionAlarm,mapPosition,mapYaw})
            }
            if(finish && !state.finish){
                proxy?.vknMessage.close();
                let chartData:any = null;
                if(state.permissionLevel == 1){
                    chartData = flyDeviationInfoRef?.value?.getChartData?.();
                }
                Object.assign(state,{
                    finish:true,
                    gradScore:score != null && score != undefined?score.toFixed(0):0,//得分
                    evaluate:isPass,
                    aiCoachSettlementData: aiCoachSettlementData ?? null,
                    gradeTotalTime:totalTime,
                })
                if(state.alarmTimer){
                    controlAlarm(false);
                }
                state.currentPage = PageName.成绩
                handleFinishMessage();
                if(state.permissionLevel == 1){
                    if(flyingState.flyDeviationViewMode != $enum.FlyDeviationViewMode.曲线){
                        flyingState.flyDeviationViewMode = $enum.FlyDeviationViewMode.曲线;
                    }
                }
                // 异步处理成绩页渲染和图片上传
                (async () => {
                    // 步骤1：等待成绩页 v-if DOM 挂载 + CSS 布局完成
                    await waitForRender();

                    // 步骤2：Canvas 迁移到成绩页容器 + 初始化渲染
                    if (state.drawer) {
                        state.drawer.toGradPage(gradCanvasRef.value);
                    }
                    if (state.permissionLevel == 1) {
                        initEcharts();
                        if (state.aiCoachSettlementData?.radar) {
                            updateRadarData(state.aiCoachSettlementData.radar);
                        }
                        if (chartData && gradeFlyDeviationInfoRef?.value) {
                            await gradeFlyDeviationInfoRef.value.importChartData(chartData);
                        }
                    }

                    // 步骤3：等待 PIXI/ECharts 渲染完成
                    await waitForRender(200);

                    // 步骤4：导出并上传图片（互不影响的 try-catch）
                    try {
                        if (state.drawer) {
                            const fileData = state.drawer.exportToImage();
                            if (fileData) {
                                storeSettlementData({
                                    evaluateData,
                                    fileData,
                                    trainingId: state.trainingId,
                                });
                            }
                        }
                    } catch (e) {
                        console.error('电子桩图片上传失败:', e);
                    }

                    if (state.permissionLevel == 1) {
                        try {
                            gradeFlyDeviationInfoRef?.value?.uploadAllChartImages?.(state.trainingId);
                        } catch (e) {
                            console.error('曲线图片上传失败:', e);
                        }
                    }
                })();
            }
        }

        if(type === 'rotatePartOneComplete'){
            showMessage('请改变旋转方向', AlarmType.操作, 3000, 'yjzldy',true)           
        }

        if(type === 'initializeEngineProgress'){
            state.engineProgress = data.data?.progress || 0
        }

        if (type === 'notifyEvaluateDetails') {
            state.subjectList = data.data;
        }

        if (type === 'loadSceneResource') {
            //  //加载成功
            // clearInterval(loadingState.timer)
            state.trainingId = store.state.persistence.currentUavInfo.trainingId;
            state.aiCoachSettlementData = null;
            state.currentPage = PageName.飞行;
            const customIndex = sceneSetting.templateList.length - 1
            const usedTemplateId = store.state.persistence.userTrainSettingInfo?.usedTemplateId
            let currentTemplateIndex = customIndex // 默认选中自定义
            if (usedTemplateId && Number(usedTemplateId) > 0) {
                const matchedIndex = sceneSetting.templateList.findIndex((item: any) => item.id === usedTemplateId)
                if(matchedIndex !== -1){
                    currentTemplateIndex = matchedIndex
                }
            }
            // 获取当前选中模板的视角参数
            const template = sceneSetting.templateList[currentTemplateIndex]
            enterOrExitUavSimulateModule({
                enter:true,
                uavSpecificationId:state.uavId,
                nestId:state.nestId,
                userId:store.state.persistence.userInfo.userId,
                tenantId:store.state.persistence.currentTenantId,
                appId:store.state.persistence.userInfo.appId,
                volume:store.state.persistence.sounds.droneSound,
                forbidAiCoach:state.permissionLevel == 1?0:1,
                canvasLimitHeight:getCanvasLimitHeight(store.state.persistence.resolution),
                openGuidStatu:state.guidStatus,
                trainingData:{
                    id:state.trainingId,
                    sceneInfo:state.sceneInfo,
                    windSpeedRange:state.windSpeedIndex,
                    windDirectionIndex:state.windDirectionIndex,
                    forbidSaveResult:'',
                    recordMode:state.permissionLevel,
                    specifiedJoystick:store.state.persistence.userTrainSettingInfo.joystickSpecification,
                    userConfig:{
                        sightHeight:template?.sightHeight || 1.6,
                        sightDist:template?.sightDist || 12,
                        sightFov:template?.sightFov || 54,
                        changeFovDist:template?.changeFovDist || 30,
                        lightDirection:store.state.persistence.userTrainSettingInfo?.lightDirection !== null && store.state.persistence.userTrainSettingInfo?.lightDirection !== undefined ? store.state.persistence.userTrainSettingInfo?.lightDirection : 5,
                        supportViewport:store.state.persistence.userTrainSettingInfo?.supportViewport || 0,
                        shadowEnable:store.state.persistence.userTrainSettingInfo?.shadowEnable ? 1 : 0,
                        distanceToCenter:store.state.persistence.userTrainSettingInfo?.distance,
                    }
                },
            })
        }

        if (type === 'modelLoading') {
             //加载中
             // const { progressData} = data.data || {}
             // loadingState.loadingStatus = progressData
             // initTimer();
            setLoadingStatus(data.data);

        }

        if(type ==='extraLoadModelFiles')
        {
            setExtraFileMap(data.data);
        }

        if(type === 'exitSimulateModuleSuccess'){
            if(state.backByExitSimulateModule){
                handleBack();
            }
        }

    })

    // 等待 DOM 更新 + 渲染帧完成
        const waitForRender = async (delay = 0): Promise<void> => {
            await nextTick();
            return new Promise(resolve => {
                requestAnimationFrame(() => {
                    if (delay > 0) {
                        setTimeout(resolve, delay);
                    } else {
                        resolve();
                    }
                });
            });
        };

    ///////////////////////////////////////////////////////  状态

    ///////////////////////////////////////////////////////  计算属性
    // 遥控器连接图标
    const connectIcon = computed(() => {
        return state.connectStatus? require("@assets/images/connect.png"): require("@assets/images/disconnect.png")
    })



    const currentTime = computed(() => {
        const progress = flyingState.currentSeconds / flyingState.totalSeconds;
        const remainTime = flyingState.totalSeconds - flyingState.currentSeconds;
        let adjustedRight;

        if (timeBox.value) {
            const rect = timeBox.value.getBoundingClientRect();
            const parentRect = timeBox.value.parentElement.getBoundingClientRect();
            const boxWidth = rect.width;
            const parentWidth = parentRect.width;

            // 计算剩余空间
            const remainingSpace = parentWidth - boxWidth;
            adjustedRight = remainingSpace * progress;
            if(flyingState.currentSeconds > 0){
               timeBox.value.style.right = `${adjustedRight}px`;
            }else if(flyingState.currentSeconds == 0){
                timeBox.value.style.right = `0px`;
            }
        }

        if (progressRef.value) {
            if(flyingState.currentSeconds >= 0){
                progressRef.value.style.width = `${adjustedRight}px`;
            }else if(flyingState.currentSeconds == 0){
                progressRef.value.style.width = `0px`;
            }
        }

        const minutes = Math.floor(remainTime / 60);
        const seconds = (remainTime % 60).toFixed(0);
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    })

    const lockIcon = computed(() => {
        if(state.lockStatus ==  $enum.SWITCH_STATUS.ON){
            return require("@/assets/images/unlock.png");
          }
          return require("@/assets/images/lock.png");
    })

    watch(() => flyingState.isShowAlarm, (newVal, oldVal) => {
        if(newVal == false && oldVal == true){
            recordProcessMessage({message: null, messageType: 'error', alarmCode:null});
        }
        controlAlarm(newVal);
    })



    ///////////////////////////////////////////////////////  监听

    ///////////////////////////////////////////////////////  方法

    const controlAlarm = (status:boolean) => {
        if(state.alarmTimer){
            clearInterval(state.alarmTimer);
            state.alarmTimer = null;
        }
        if(status){
            proxy?.vknMessage.close();
            state.alarmTimeCount = 10;
            showMessage(`你已进入限制区域，${state.alarmTimeCount}秒后将自动重置。`, AlarmType.异常,0, 'gjts',true)
            state.alarmTimer = setInterval(() => {
                state.alarmTimeCount--;
                if(state.alarmTimeCount == 0){
                    proxy?.vknMessage.close();
                    clearInterval(state.alarmTimer);
                    state.alarmTimer = null;
                    handleSwitch('reset')
                }
            }, 1000);
        }
    }

    const showMessage = async (message: string, alarmType: AlarmType.操作 | AlarmType.异常 | null, duration?:number, icon?:string, useVoice?:true | false, alarmCode?:string | null | undefined) => {
        if(alarmType){
            state.alarmType = alarmType;
        }
        if(alarmType == AlarmType.异常){
            if(state.currentErrorMessage !== message){
                if(state.currentErrorMessage){
                    recordProcessMessage({message: null, messageType: 'error', alarmCode:state.currentErrorAlarmCode});
                }
            }
            recordProcessMessage({message, messageType: 'error',messageDuration:duration, alarmCode});

            state.currentErrorMessage = message
            state.currentErrorAlarmCode = alarmCode;
        }
        if(alarmType == AlarmType.操作){
            if(state.currentInfoMessage !== message){
                if(state.currentInfoMessage){
                     recordProcessMessage({message: null, messageType: 'info'});
                }
            }
            recordProcessMessage({message, messageType: 'info',messageDuration:0});
            state.currentInfoMessage = message
        }
        if(useVoice && state.showAiInstructor){
            state.promptText = message;
        }
    }

    const hasFlowStep = (stepNameList:any, keyword:string) => {
        return Array.isArray(stepNameList) && stepNameList.some((step:string) => {
            return typeof step === 'string' && step.includes(keyword)
        })
    }

    const getHoverDirection = (stepNameList:any, currentStepIndex:number) => {
        const stepName = stepNameList?.[currentStepIndex] || state.sceneInfo?.sceneSubTypeName || ''
        return stepName.match(/对尾|对头|对左|对右/)?.[0] || '对尾'
    }

    //普通提示
    const normalPrompt = (options:any)=>{
        let {currentStepIndex,overLimit,stepNameList,arriveCenter,targetTime,isReady, collisionAlarm} = options || {};
        const hasUnlockStep = hasFlowStep(stepNameList, '解锁')
        const hasLandingStep = hasFlowStep(stepNameList, '降落')
        const canHandleActionStep = Array.isArray(stepNameList) && (currentStepIndex > 0 || !hasUnlockStep) && (hasUnlockStep || isReady)
        const flyToCenterPrompt = hasUnlockStep ? '请提升飞行高度至1.5米以上，并飞至中心桶悬停对尾' : '请保持1.5m以上高度，并飞至中心桶悬停对尾'
        const hoverDirection = getHoverDirection(stepNameList, currentStepIndex)
        if(sceneMode.value != SceneMode.悬停 && hasUnlockStep && isReady && currentStepIndex == 0 && flyingState.currentMessage == MassageType.无){
            flyingState.currentMessage = MassageType.解锁;
            setTimeout(() => {
                proxy?.vknMessage.close();
                showMessage($tips.OPEN_TIPS, AlarmType.操作, 0,'yjzldy',true)
            }, 500);
        }
        if(sceneMode.value == SceneMode.悬停 && isReady && flyingState.currentMessage == MassageType.无){
            if(state.timer){
                clearTimeout(state.timer);
                state.timer = null;
            }
            proxy?.vknMessage.close();
            flyingState.currentMessage = MassageType.悬停;
            operationPrompt.hoverStarted = false;
            showMessage(`请保持1.5m以上高度，并飞至中心桶悬停${hoverDirection}`, AlarmType.操作, 0, 'yjzldy',true)
        }
        if(sceneMode.value == SceneMode.悬停 && isReady && arriveCenter && flyingState.currentMessage == MassageType.悬停 && !operationPrompt.hoverStarted){
            operationPrompt.hoverStarted = true;
            proxy?.vknMessage.close();
            showMessage(`已到达中心桶，请保持${hoverDirection}`, AlarmType.操作, 3000, 'yjzldy',true)
            if(state.timer){
                clearTimeout(state.timer);
                state.timer = null;
            }
            state.timer = setTimeout(() => {
                proxy?.vknMessage.close();
                showMessage(`开始${hoverDirection}悬停，保持悬停达到${targetTime ?? 30}秒`, AlarmType.操作, 5000, 'yjzldy',true)
            }, 3500);
        }
        if(canHandleActionStep && overLimit == 0){
            const canStartFirstAction = flyingState.currentMessage == MassageType.解锁 || (!hasUnlockStep && flyingState.currentMessage == MassageType.无)
            if(stepNameList[currentStepIndex] && /自旋/.test(stepNameList[currentStepIndex]) && canStartFirstAction){
                proxy?.vknMessage.close();
                flyingState.currentMessage = MassageType.自转;
                showMessage(flyToCenterPrompt, AlarmType.操作, 0, 'yjzldy',true)
            }
            if(stepNameList[currentStepIndex] && /字/.test(stepNameList[currentStepIndex]) && (canStartFirstAction || flyingState.currentMessage == MassageType.自转)){
                proxy?.vknMessage.close();
                flyingState.currentMessage = MassageType.八字;
                if(sceneMode.value == SceneMode.全科){
                    if(!arriveCenter){
                        operationPrompt.spinCompleted = true;
                        showMessage(`${stepNameList[currentStepIndex - 1]}完成，请飞至中心桶`, AlarmType.操作, 5000, 'yjzldy',true)
                    }
                }else{
                    showMessage(flyToCenterPrompt, AlarmType.操作, 0, 'yjzldy',true)
                }

            }

            if(hasLandingStep && stepNameList[currentStepIndex] && /降落/.test(stepNameList[currentStepIndex]) && (flyingState.currentMessage == MassageType.自转 || flyingState.currentMessage == MassageType.八字)){
                proxy?.vknMessage.close();
                flyingState.currentMessage = MassageType.降落;
                showMessage("飞行完成，请将无人机降落", AlarmType.操作, 5000, 'yjzldy',true)
            }
            if(arriveCenter && (sceneMode.value != SceneMode.无 && sceneMode.value != SceneMode.悬停)){
                proxy?.vknMessage.close();
                if(sceneMode.value == SceneMode.全科 && flyingState.currentMessage == MassageType.八字){
                    operationPrompt.delayTime = 5000
                    if(operationPrompt.spinCompleted){
                        operationPrompt.spinCompleted = false;
                        showMessage('已到达中心桶，请保持对尾', AlarmType.操作, 3000, 'yjzldy',true)
                    }else{
                        showMessage(`${stepNameList[currentStepIndex - 1]}完成，已到达中心桶，请保持对尾`, AlarmType.操作, 3000, 'yjzldy',true)
                    }
                }else{
                    showMessage('已到达中心桶，请保持对尾', AlarmType.操作, 3000, 'yjzldy',true)
                }
                if(state.timer){
                    clearTimeout(state.timer);
                    state.timer = null;
                }
                state.timer = setTimeout(() => {
                    proxy?.vknMessage.close();
                    showMessage(`${stepNameList[currentStepIndex]}开始，倒计时${targetTime}秒`, AlarmType.操作, 5000, 'yjzldy',true)
                    if(operationPrompt.delayTime == 5000){
                        operationPrompt.delayTime = 3000
                    }
                }, operationPrompt.delayTime);
            }
        }
    }

    //异常提示
    const abnormalPrompt = (data:any)=>{
        const {collisionAlarm} = data || {};
        if(collisionAlarm && !flyingState.evaluateStatus.collisionAlarm){
            flyingState.evaluateStatus.collisionAlarm = true;
            proxy?.vknMessage.close();
            showMessage("注意障碍物，谨慎飞行", AlarmType.异常, 0,'yjzldy',true)
        }

        if(!collisionAlarm && flyingState.evaluateStatus.collisionAlarm){
            flyingState.evaluateStatus.collisionAlarm = false;
        }

        if(!flyingState.arriveCenter || flyingState.currentMessage == MassageType.降落){
            return
        }

        const {heightOffset, positionOffset, time, angleOffset, angleSpeedOffset, speedOffset} = data?.evaluateData || {};
        const mapPosition = data?.mapPosition || {};
        const mapYaw = data?.mapYaw || {};

        if(heightOffset){
            if(!flyingState.evaluateStatus.height && heightOffset?.realTimeValue > heightOffset?.maxValue){
                flyingState.evaluateStatus.height = true;
                proxy?.vknMessage.close();
                showMessage("高度偏差过大", AlarmType.异常, 3000, 'gjts',true,heightOffset?.code)
                state.drawer.drawCircle({
                    x:mapPosition.x,
                    y:mapPosition.y,
                    yaw:mapYaw
                },colorMap["height"]);
            } else if (flyingState.evaluateStatus.height && heightOffset?.realTimeValue <= heightOffset?.maxValue) {
                flyingState.evaluateStatus.height = false;
            }
        }

        if(positionOffset){
            if(!flyingState.evaluateStatus.position && positionOffset?.realTimeValue > positionOffset?.maxValue){
                flyingState.evaluateStatus.position = true;
                proxy?.vknMessage.close();
                showMessage("位置偏差过大", AlarmType.异常, 3000, 'gjts',true,positionOffset?.code)
                state.drawer.drawCircle({
                    x:mapPosition.x,
                    y:mapPosition.y,
                    yaw:mapYaw
                },colorMap["position"]);
            } else if (flyingState.evaluateStatus.position && positionOffset?.realTimeValue <= positionOffset?.maxValue) {
                flyingState.evaluateStatus.position = false;
            }
        }

        if(time && Array.isArray(time) && time.length){
            let timeIndex = Number(flyingState.evaluateStatus.time);
            if (timeIndex < time.length) {
                let needAlarm = false;
                for (let index = timeIndex; index < time.length; index++) {
                    if (time[index]?.value > time[index]?.maxValue) {
                        needAlarm = true;
                        break;
                    }
                }
                if (needAlarm) {
                    flyingState.evaluateStatus.time++;
                    proxy?.vknMessage.close();
                    showMessage("飞行超时", AlarmType.异常, 3000, 'gjts',true,time[0].code)
                    // TODO: 临时修改，超时后结束，便于测试结果页
                    // handleSwitch('reset')
                    state.drawer.drawCircle({
                        x:mapPosition.x,
                        y:mapPosition.y,
                        yaw:mapYaw
                    },colorMap["timeDeviation"]);
                }

            }
        }

        if(angleOffset){
            if (!flyingState.evaluateStatus.angle && (angleOffset?.realTimeValue > angleOffset?.maxValue || angleOffset?.realTimeValue < angleOffset?.minValue)) {
                flyingState.evaluateStatus.angle = true;
                proxy?.vknMessage.close();
                showMessage("航向夹角过大", AlarmType.异常, 3000, 'gjts', true, angleOffset?.code)
                state.drawer.drawCircle({
                    x: mapPosition.x,
                    y: mapPosition.y,
                    yaw: mapYaw
                }, colorMap["headAngle"]);
            } else if (flyingState.evaluateStatus.angle && angleOffset?.realTimeValue <= angleOffset?.maxValue && angleOffset?.realTimeValue >= angleOffset?.minValue) {
                flyingState.evaluateStatus.angle = false;
            }
        }


        if(angleSpeedOffset && flyingState.currentMessage == MassageType.自转){
            if (!flyingState.evaluateStatus.angleMinSpeed && angleSpeedOffset?.underMin/* && angleSpeedOffset?.realTimeValue < angleSpeedOffset?.minValue*/) {
                flyingState.evaluateStatus.angleMinSpeed = true;
                proxy?.vknMessage.close();
                showMessage("角速度过小", AlarmType.异常, 3000, 'gjts',true, angleSpeedOffset?.code)
                state.drawer.drawCircle({
                    x:mapPosition.x,
                    y:mapPosition.y,
                    yaw:mapYaw
                },colorMap["angle"]);
            }

            if(!flyingState.evaluateStatus.angleMaxSpeed && angleSpeedOffset?.realTimeValue > angleSpeedOffset?.maxValue){
                flyingState.evaluateStatus.angleMaxSpeed = true;
                proxy?.vknMessage.close();
                showMessage("角速度过大", AlarmType.异常, 3000, 'gjts',true,angleSpeedOffset?.code)
                state.drawer.drawCircle({
                    x:mapPosition.x,
                    y:mapPosition.y,
                    yaw:mapYaw
                },colorMap["angle"]);
            }

        }

        if(speedOffset && flyingState.currentMessage == MassageType.八字){
            if (!flyingState.evaluateStatus.minSpeed && speedOffset?.underMin && speedOffset?.realTimeValue < speedOffset?.minValue) {
                flyingState.evaluateStatus.minSpeed = true;
                proxy?.vknMessage.close();
                showMessage("速度过小", AlarmType.异常, 3000, 'gjts', true,speedOffset?.code)
                state.drawer.drawCircle({
                    x: mapPosition.x,
                    y: mapPosition.y,
                    yaw: mapYaw
                }, colorMap["speed"]);
            } else if (flyingState.evaluateStatus.minSpeed && speedOffset?.underMin && speedOffset?.realTimeValue >= speedOffset?.minValue) {
                flyingState.evaluateStatus.minSpeed = false;
            }
            if (!flyingState.evaluateStatus.maxSpeed && speedOffset.realTimeValue > speedOffset.maxValue) {
                flyingState.evaluateStatus.maxSpeed = true;
                proxy?.vknMessage.close();
                showMessage("速度过大", AlarmType.异常, 3000, 'gjts', true, speedOffset?.code)
                state.drawer.drawCircle({
                    x: mapPosition.x,
                    y: mapPosition.y,
                    yaw: mapYaw
                }, colorMap["speed"]);
            } else if (flyingState.evaluateStatus.maxSpeed && speedOffset?.realTimeValue <= speedOffset?.maxValue) {
                flyingState.evaluateStatus.maxSpeed = false;
            }
        }
    }

    //成绩页面中的重新开始按钮
    async function handleRestart(isBeforeUnload?:false | true){
        window?.playClick()
        const hasUnlockStep = hasFlowStep(flyingState.uavStatusList, '解锁')
         //1. 调用后端接口生成一个训练id
         let param = {
            sceneId:store.state.persistence.currentUavInfo.sceneInfo.id,
            uavSpecificationId:state.uavId,
            userId:store.state.persistence.userInfo.userId,
            windPower:store.state.persistence.userTrainSettingInfo.windPower,
            windDirection:store.state.persistence.userTrainSettingInfo.windDirection,
            stationId:state.stationdId,
        }
        const {code, data} = await createTraining(param);
        if(code != $enum.EnumResult.SUCCESS){
            // showMessage("创建新训练失败！")
            return;
        }
        const {trainingId} = data as any || {};
        //2. 通过后端返回的trainingid更新store里面的trainingid
        store.commit('persistence/setCurrentUavInfo', {
            ...store.state.persistence.currentUavInfo,
            trainingId: trainingId
        });
        state.trainingId = trainingId;
        state.aiCoachSettlementData = null;
        //3. 调用webapi接口重新开始
        resetView({
            trainingId,
            windSpeedRange:state.windSpeedIndex,
            windDirectionIndex:state.windDirectionIndex,
            openGuidStatu:state.guidStatus
        })
        //1. 重置飞行状态页面的状态,
        Object.assign(flyingState,{
            evaluateStatus:{
                height:false,
                position:false,
                time:false,
                angle:false,
                angleMaxSpeed:false,
                angleMinSpeed:false,
                maxSpeed:false,
                minSpeed:false,
                calculateAngleSpeed:false,
                calculateMinSpeed:false,
                collisionAlarm:false
            },
            totalSeconds: -1, // 飞行总时间 秒
            currentSeconds: 0, // 当前时间 秒
            uavStatusList: [],
            currentStepIndex:0,
            altitude:0,  //高度
            horizonalSpeed:0,//速度
            courseAngle:0, //航向角
            realTimeAngleOffset:flyingState.realTimeAngleOffset !== undefined?0:undefined,//航向夹角
            angularSpeed:0,//角速度
            currentMessage:MassageType.无,
            onGround:false,
            arriveCenter:0,//是否到达中心
            flyingInfo:{},
            uavIconAngle:0
        })
        //5. 重置进度条
        if (timeBox.value) {
            timeBox.value.style.right = `0%`;
        }
        if (progressRef.value) {
            progressRef.value.style.width = `0%`;
        }
        //6. 关闭成绩页面，打开飞行页面
        setTimeout(() => {
            state.drawer?.toFlyingPage();
        }, 300);
        if(!isBeforeUnload){
            state.currentPage = PageName.飞行;
            proxy?.vknMessage.close();
            if(state.permissionLevel == 1){
                if(flyingState.flyDeviationViewMode == $enum.FlyDeviationViewMode.曲线){
                    flyingState.flyDeviationViewMode = $enum.FlyDeviationViewMode.卡片;
                }
                // 重置曲线数据
                flyDeviationInfoRef?.value?.resetCharts()
            }

            if(sceneMode.value != SceneMode.悬停 && hasUnlockStep){
                flyingState.currentMessage = MassageType.解锁;
                setTimeout(() => {
                    showMessage($tips.OPEN_TIPS, AlarmType.操作, 0,'yjzldy',true)
                }, 1000);
            }
        }else{
            state.currentPage = PageName.加载中;
        }
    }


    /**
     * 切换状态
     * @param type
     */
    async function handleSwitch(type:string,fromNotify = false){
        window?.playClick()
        // flyDeviationInfoRef?.value?.uploadAllChartImages(state.trainingId);
        if(type == 'guid'){
            //关闭开启引导
            const enableGuide = !state.guidStatus
            let params = {
                userId: store.state.persistence.userInfo.userId,
                tenantId: store.state.persistence.currentTenantId,
                sceneTypeId: store.state.persistence.breadcrumb[store.state.persistence.breadcrumb.length-2].id,
                enableGuide
            }
            let {code,data,message} = await saveUserTrainingSetting(params) as any
            if(code != $enum.EnumResult.SUCCESS || data != true){
                return;
            }

            store.commit('persistence/setUserTrainingSetting', {
                ...store.state.persistence.userTrainSettingInfo,
                enableGuide
            })
            switchOpenGuid({open:enableGuide?1:0});
        }else if(type == 'view'){
            //切换视角
            switchView()
        }else{
            //重置
            const hasUnlockStep = hasFlowStep(flyingState.uavStatusList, '解锁')
            if(state.permissionLevel == 1){
                if(flyingState.flyDeviationViewMode == $enum.FlyDeviationViewMode.曲线){
                    flyingState.flyDeviationViewMode = $enum.FlyDeviationViewMode.卡片;
                }
                flyDeviationInfoRef?.value?.resetCharts()
            }
            flyingState.resetting = 5;
            flyingState.arriveCenter = 0;
            if(sceneMode.value == SceneMode.悬停 || flyingState.currentStepIndex > 0 || !hasUnlockStep){
                stop()
                state.showPrompt = false;
                state.promptText = '';
                flyingState.currentMessage = MassageType.无;
                if(!fromNotify)
                {
                    resetView({
                        windSpeedRange:state.windSpeedIndex,
                        windDirectionIndex:state.windDirectionIndex,
                        openGuidStatu:state.guidStatus
                    })
                }
                if (timeBox.value) {
                    timeBox.value.style.right = `0%`;
                }
                if (progressRef.value) {
                    progressRef.value.style.width = `0%`;
                }
                if(state.alarmTimer){
                    controlAlarm(false);
                }
                Object.assign(flyingState,{
                    flyingInfo:{},
                    evaluateStatus:{
                        height:false,
                        position:false,
                        time:false,
                        angle:false,
                        angleMaxSpeed:false,
                        angleMinSpeed:false,
                        maxSpeed:false,
                        minSpeed:false,
                        calculateAngleSpeed:false,
                        calculateMinSpeed:false,
                        collisionAlarm:false,
                    },
                })
                if(sceneMode.value != SceneMode.悬停 && hasUnlockStep){
                    flyingState.currentMessage = MassageType.解锁;
                    setTimeout(() => {
                        showMessage($tips.OPEN_TIPS, AlarmType.操作, 0,'yjzldy',true)
                    }, 1000);
                }
            }
        }
    }

    const handlerResiz = ()=>{
        if(state.drawer){
            state.drawer.resizeHandler(state.lockStatus == $enum.SWITCH_STATUS.OFF);
        }
        checkTextOverflow();
        resizeEcharts()
    }

    function handleBeforeUnload(e: BeforeUnloadEvent) {
        window.speechSynthesis.cancel()
        store.commit("viewData/setEnterScene", false);
        store.commit('persistence/setCurrentUavInfo', {
            ...store.state.persistence.currentUavInfo,
            trainingId: null
        });
    }

    function handleLock(){
        if(state.lockStatus == $enum.SWITCH_STATUS.ON && !flyingState.onGround){
            return;
        }
        let lock = -1;
        if(state.lockStatus == $enum.SWITCH_STATUS.OFF){
            lock = 1;
        }else{
            lock = 0;
        }
        window?.playClick()
        switchUnlockUav({unlock:lock})
    }

    function handleVisibilityChange(){
        if(document.visibilityState == "hidden"){
            state.pageVisible = false;
            state.canSetFps = false;
        }else{
            setTimeout(() => {
                state.pageVisible = true;
            }, 300);
            setTimeout(() => {
                state.canSetFps = true;
            }, 1500);
        }
    }
    function handleKeyDown(event:any)
    {
        if (state.currentPage == PageName.成绩) {
            if (event.key == "Escape") {
                handleBack('Escape');
            }
            return;
        }
        if(state.currentPage == PageName.设置) return;
        forceGainFocus({key: event.key});
    }

    function closeAiInstructor(){
        window?.playClick()
        if(state.showPrompt){
            state.showPrompt = false;
            state.promptText = ''
            stop()
        }
        state.showAiInstructor = false;
    }

    function switchAiInstructor(type:string){
        window?.playClick()
        if(type == 'open'){
            state.showAiInstructor = true;
        }else{
            state.showAiInstructor = false;
            stop()
        }
        if(state.showPrompt){
            state.showPrompt = false;
            state.promptText = ''
        }
    }

    function openFlyReplay(){
        window?.playClick()
        const deviationInfo = Object.keys(flyingState.flyingInfo).filter(key => key !== 'timeDeviation').reduce((obj: any, key) => {obj[key] = flyingState.flyingInfo[key].name;return obj;}, {})
        store.commit('viewData/setFlyReplayData', {
            title: state.loading3D.title,
            score: state.gradScore,
            isPass: state.evaluate,
            rating: state.aiCoachSettlementData?.rating,
            abilityData: state.aiCoachSettlementData?.radar,
            flightSummary: state.aiCoachSettlementData?.flightConclusion,
            trainingSuggestion: state.aiCoachSettlementData?.trainingSuggestion,
            windDirection: state.userWaserInfo.windDirectionIndex === undefined || state.userWaserInfo.windDirectionIndex === null ? -1 : state.userWaserInfo.windDirectionIndex,
            windSpeed: state.userWaserInfo.windSpeedIndex === undefined || state.userWaserInfo.windSpeedIndex === null ? -1 : state.userWaserInfo.windSpeedIndex,
            pageMode: 1,
            enterMode: 1,
            trainingId: state.trainingId,
            deviationInfo,
            enterPageMode: 1,
        })
        store.commit('viewData/setShowFlyReplay', true)
    }

    // 监听 store 中 flyReplay 关闭事件（从 App.vue 的 close 按钮触发）
    watch(() => store.getters['viewData/showFlyReplay'], (newVal, oldVal) => {
        if (oldVal === true && newVal === false) {
            resetView()
        }
    })

    async function checkTextOverflow(){
        await nextTick();
        if(!promptRef.value || !promptTextRef.value || !state.showPrompt){
            return;
        }
        const promptContainerW = promptRef?.value.clientWidth;
        const promptTextW = promptTextRef?.value.scrollWidth;
        state.isMarqueeActive = promptTextW > promptContainerW;
    }
    function handleSwitchSetting(type:string){
        window?.playClick()
        if(!flyingState.isReady) return;
        // 获取自定义模式的索引（最后一项）
        const customIndex = sceneSetting.templateList.length - 1
        // 将 store 缓存的值赋给自定义模式项
        sceneSetting.templateList[customIndex] = {
            ...sceneSetting.templateList[customIndex],
            sightHeight: store.state.persistence.userTrainSettingInfo?.sightHeight || 0,
            sightDist: store.state.persistence.userTrainSettingInfo?.sightDist || 0,
            sightFov: store.state.persistence.userTrainSettingInfo?.sightFov || 0,
            changeFovDist: store.state.persistence.userTrainSettingInfo?.changeFovDist || 0,
        }
        // 根据 usedTemplateId 计算默认选中的模板索引
        const usedTemplateId = store.state.persistence.userTrainSettingInfo?.usedTemplateId
        let defaultPerspectiveTab = customIndex // 默认选中自定义
        if(usedTemplateId){
            const matchedIndex = sceneSetting.templateList.findIndex((item: any) => item.id === usedTemplateId)
            if(matchedIndex !== -1){
                defaultPerspectiveTab = matchedIndex
            }
        }
        // 获取当前选中模板的视角参数
        const template = sceneSetting.templateList[defaultPerspectiveTab]
        Object.assign(sceneSetting,{
            sightHeight: template?.sightHeight || 0,
            sightDist: template?.sightDist || 0,
            sightFov: template?.sightFov || 0,
            changeFovDist: template?.changeFovDist || 0,
            lightDirection: store.state.persistence.userTrainSettingInfo?.lightDirection !== null && store.state.persistence.userTrainSettingInfo?.lightDirection !== undefined ? store.state.persistence.userTrainSettingInfo?.lightDirection : -1,
            showAuxiliaryViewport: store.state.persistence.userTrainSettingInfo?.supportViewport || false,
            shadowEnable: store.state.persistence.userTrainSettingInfo?.shadowEnable || false,
            centerBucketDist: store.state.persistence.userTrainSettingInfo?.distance || 6,
            perspectiveTab: defaultPerspectiveTab,
        })
        if(type == 'open'){
            if(state.showPrompt){
                state.showPrompt = false;
                state.promptText = ''
                stop()
            }
            state.currentPage = PageName.设置;
            setPause({statu:1})
        }else{
            handleRefreshUserConfig()
            state.currentPage = PageName.飞行;
            setPause({statu:0})
        }
    }

    // 切换视角Tab
    function handleSwitchPerspectiveTab(index: number){
        window?.playClick()
        sceneSetting.perspectiveTab = index
        // 从对应的模板（包括自定义）获取视角参数
        const template = sceneSetting.templateList[index]
        if(template){
            sceneSetting.sightHeight = template.sightHeight
            sceneSetting.sightDist = template.sightDist
            sceneSetting.sightFov = template.sightFov
            sceneSetting.changeFovDist = template.changeFovDist
            handleRefreshUserConfig()
        }
    }

    //场景设置传递给三维
    function handleRefreshUserConfig(){
        const reg = /^[+-]?(\d+(\.\d*)?|\.\d+)$/;
        if(!reg.test(sceneSetting.sightHeight)){
            sceneSetting.sightHeight = 1;
        }
        if(!reg.test(sceneSetting.sightDist)){
            sceneSetting.sightDist = 9;
        }
        if(!reg.test(sceneSetting.sightFov)){
            sceneSetting.sightFov = 40;
        }
        if(!reg.test(sceneSetting.changeFovDist)){
            sceneSetting.changeFovDist = 12;
        }
        if(!reg.test(sceneSetting.centerBucketDist)){
            sceneSetting.centerBucketDist = 6;
        }
        // 自定义模式下，同步更新 templateList 中自定义模式项的视角参数
        if(isCustomPerspective.value){
            const customIndex = sceneSetting.templateList.length - 1
            sceneSetting.templateList[customIndex] = {
                ...sceneSetting.templateList[customIndex],
                sightHeight: sceneSetting.sightHeight,
                sightDist: sceneSetting.sightDist,
                sightFov: sceneSetting.sightFov,
                changeFovDist: sceneSetting.changeFovDist,
            }
        }
        refreshUserConfig({
            userConfig: {
                sightHeight: sceneSetting.sightHeight,
                sightDist: sceneSetting.sightDist,
                sightFov: sceneSetting.sightFov,
                changeFovDist: sceneSetting.changeFovDist,
                lightDirection: sceneSetting.lightDirection,
                supportViewport: sceneSetting.showAuxiliaryViewport ? 1 : 0,
                shadowEnable: sceneSetting.shadowEnable ? 1 : 0,
                distanceToCenter: sceneSetting.centerBucketDist,
            }
        })
    }

    async function handleConfirm(){
        window?.playClick()
        if(sceneSetting.resetLoading) return;
        sceneSetting.confirmLoading = true;
        // 计算当前选中的模板 id（自定义模式为 null）
        const usedTemplateId = isCustomPerspective.value ? 0 : sceneSetting.templateList[sceneSetting.perspectiveTab]?.id || 0
        // 获取自定义模式的索引（最后一项）
        const customIndex = sceneSetting.templateList.length - 1
        // 同步更新自定义模式项的视角参数
        sceneSetting.templateList[customIndex] = {
            ...sceneSetting.templateList[customIndex],
            sightHeight: sceneSetting.sightHeight,
            sightDist: sceneSetting.sightDist,
            sightFov: sceneSetting.sightFov,
            changeFovDist: sceneSetting.changeFovDist,
        }
        // 视角参数从自定义模式项获取
        const customTemplate = sceneSetting.templateList[customIndex]
        let params = {
            userId: store.state.persistence.userInfo.userId,
            tenantId: store.state.persistence.currentTenantId,
            sceneTypeId: store.state.persistence.breadcrumb[store.state.persistence.breadcrumb.length-2].id,
            sightHeight: customTemplate.sightHeight,
            sightDist: customTemplate.sightDist,
            sightFov: customTemplate.sightFov,
            changeFovDist: customTemplate.changeFovDist,
            lightDirection:sceneSetting.lightDirection,
            supportViewport:sceneSetting.showAuxiliaryViewport,
            shadowEnable:sceneSetting.shadowEnable,
            distance: sceneSetting.centerBucketDist,
            usedTemplateId: usedTemplateId,
        }
        let {code,data,message} = await saveUserTrainingSetting(params) as any
        sceneSetting.confirmLoading = false;
        if(code != $enum.EnumResult.SUCCESS || data != true){
            showErrorMessage('保存场景设置失败')
            return;
        }

        //更新本地缓存：只有自定义模式才更新视角参数
        const newSetting: any = {
            ...store.state.persistence.userTrainSettingInfo,
            lightDirection:sceneSetting.lightDirection,
            supportViewport:sceneSetting.showAuxiliaryViewport,
            shadowEnable:sceneSetting.shadowEnable,
            distance: sceneSetting.centerBucketDist,
            usedTemplateId: usedTemplateId,
        }
        if(isCustomPerspective.value){
            newSetting.sightHeight = sceneSetting.sightHeight
            newSetting.sightDist = sceneSetting.sightDist
            newSetting.sightFov = sceneSetting.sightFov
            newSetting.changeFovDist = sceneSetting.changeFovDist
        }
        store.commit('persistence/setUserTrainingSetting', newSetting)

        //更新三维
        handleRefreshUserConfig()

         //关闭场景设置
        state.currentPage = PageName.飞行;
        setPause({statu: 0, confirmUserConfig: 1})
    }

    async function handleReset(){
        window?.playClick()
        if(sceneSetting.confirmLoading) return;
        let {code,data,message} = await getDefaultTrainingSetting({}) as any
        if(code != $enum.EnumResult.SUCCESS || (!data || Object.keys(data).length == 0)){
            showErrorMessage('恢复默认场景设置失败')
            return;
        }
        let {sightHeight, sightDist, sightFov, changeFovDist, lightDirection, supportViewport, shadowEnable, distance, usedTemplateId} = data || {}
        // 获取自定义模式的索引（最后一项）
        const customIndex = sceneSetting.templateList.length - 1
        // 更新自定义模式项的视角参数
        sceneSetting.templateList[customIndex] = {
            ...sceneSetting.templateList[customIndex],
            sightHeight: sightHeight || 0,
            sightDist: sightDist || 0,
            sightFov: sightFov || 0,
            changeFovDist: changeFovDist || 0,
            id:0,
        }
        // 确定默认选中的模板索引
        let defaultPerspectiveTab = customIndex // 默认选中自定义
        if(usedTemplateId){
            const matchedIndex = sceneSetting.templateList.findIndex((item: any) => item.id === usedTemplateId)
            if(matchedIndex !== -1){
                defaultPerspectiveTab = matchedIndex
            }
        }
        // 获取当前选中模板的视角参数
        const template = sceneSetting.templateList[defaultPerspectiveTab]
        Object.assign(sceneSetting,{
            sightHeight: template?.sightHeight || 0,
            sightDist: template?.sightDist || 0,
            sightFov: template?.sightFov || 0,
            changeFovDist: template?.changeFovDist || 0,
            lightDirection: lightDirection !== null && lightDirection !== undefined ? lightDirection : -1,
            showAuxiliaryViewport: supportViewport || false,
            shadowEnable: shadowEnable || false,
            centerBucketDist: distance || 6,
            perspectiveTab: defaultPerspectiveTab,
            usedTemplateId: usedTemplateId,
        })
        handleRefreshUserConfig()
    }

    function showErrorMessage(message:string){
        proxy?.vknMessage.warning({
            message: message,
            duration:3000,
            offset: 100,
        }, 'gjts')
    }

    function handleInput(value:number){
        if (value === null) return;
        const filtered = value.toString().replace(/[^\d.]/g, '');
         const valid = filtered
        .replace(/^\./g, '') // 去掉开头的小数点
        .replace(/\.{2,}/g, '.') // 多个小数点只保留第一个
        .replace(/\.$/g, ''); // 去掉结尾的小数点
        // 更新值（避免死循环，需判断是否变化）
        if (valid !== value.toString()) {
            sceneSetting.sightHeight = valid === '' ? null : Number(valid);
        }
    }

    function openSubjectModal(){
        if(!flyingState.isReady) return;
        state.showSubjectModal = true;
    }

    function handleBackCallback(type?: string){
        state.backByExitSimulateModule = true;
        enterOrExitUavSimulateModule({enter:false});
    }

    async function getTemplateTrainingSet(){
        let {code,data,message} = await getTemplateTrainingSetting({}) as any
        if(code != $enum.EnumResult.SUCCESS || (!data || !Array.isArray(data))){
            showErrorMessage('获取模板训练数据设置失败')
            return
        }
        // 存储模板数据列表，追加自定义模式项
        sceneSetting.templateList = [
            ...data,
            {
                id: 0,
                templateName: '自定义',
                sightHeight: sceneSetting.sightHeight,
                sightDist:sceneSetting.sightDist,
                sightFov: sceneSetting.sightFov,
                changeFovDist: sceneSetting.changeFovDist
            }
        ]
    }

    //结束消息提示
    function handleFinishMessage(){
        if(state.currentInfoMessage){
            recordProcessMessage({message: null, messageType: 'info'});
            state.currentInfoMessage = null;
        }
        if(state.currentErrorMessage){
            recordProcessMessage({message: null, messageType: 'error', alarmCode:state.currentErrorAlarmCode});
            state.currentErrorMessage = null;
            state.currentErrorAlarmCode = null;
        }
    }

    ///////////////////////////////////////////////////////  生命周期
    onBeforeMount(async() => {
        // 获取模板数据
        await getTemplateTrainingSet()
    })
    onMounted(async () => {
        await nextTick();
        if(timeBoxRef.value){
            state.containerWidth = timeBoxRef.value?.offsetWidth;
        }
        window.addEventListener('resize', handlerResiz)
        window.addEventListener('beforeunload', handleBeforeUnload)
        document.addEventListener('visibilitychange', handleVisibilityChange);
        document.addEventListener('keydown', handleKeyDown);
        checkTextOverflow();
        initEcharts()

    })

    onBeforeUnmount(() => {
        handleFinishMessage()
        if(!state.backByExitSimulateModule){
            enterOrExitUavSimulateModule({enter:false})
        }
        showOrHideEngineView(false)
        store.commit("viewData/setEnterScene", false);
        if(state.alarmTimer){
            controlAlarm(false);
        }
        if(state.drawer){
            state.drawer.destroy();
        }
        proxy?.vknMessage.close();

        if(state.timer){
            clearTimeout(state.timer);
            state.timer = null;
        }
        proxy?.vknMessage.close();
        window.removeEventListener('resize', handlerResiz);
        if(state.alarmTimer){
            controlAlarm(false);
        }
        window.removeEventListener('beforeunload', handleBeforeUnload);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        document.removeEventListener('keydown', handleKeyDown);
        if(store.getters['viewData/showFlyReplay']){
            store.commit('viewData/setShowFlyReplay', false)
        }
    })

    ///////////////////////////////////////////// 测试

    return {
        ...toRefs(state),
        ...toRefs(loadingState),
        ...toRefs(flyingState),
        ...toRefs(sceneSetting),
        $config,
        $enum,
        AlarmType,
        connectIcon,
        currentTime,
        engineInitialized,
        lockIcon,
        gradTotalTime,
        loadingProgess,
        lightDirectionList,
        perspectiveTabList,
        isCustomPerspective,
        subjectTitle,

        handleBack,
        handleBackCallback,
        handleRestart,
        handleSwitch,
        handleLock,
        closeAiInstructor,
        switchAiInstructor,
        handleOpenPDF,
        handleSwitchSetting,
        handleSwitchPerspectiveTab,
        handleOpenSettingFullscreen,
        handleReset,
        handleConfirm,
        handleRefreshUserConfig,
        openSubjectModal,
        openFlyReplay,
        speak,
        stop,
        currentWindDirection
    }
}
